import React, { useEffect, useRef } from 'react';

const StarryBackground = () => {
  const canvasRef = useRef(null);
  const starsRef = useRef([]);
  const animationFrameRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    let width = window.innerWidth;
    let height = window.innerHeight;

    // Imposta dimensioni canvas
    const resizeCanvas = () => {
      width = window.innerWidth;
      height = window.innerHeight;
      canvas.width = width;
      canvas.height = height;
    };
    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);

    // Crea stelle
    const createStars = () => {
      const stars = [];
      const numStars = Math.floor((width * height) / 8000); // Densità stelle
      
      for (let i = 0; i < numStars; i++) {
        stars.push({
          x: Math.random() * width,
          y: Math.random() * height,
          z: Math.random() * 2000,
          size: Math.random() * 2 + 0.5,
          speed: Math.random() * 0.5 + 0.1,
          opacity: Math.random() * 0.5 + 0.3,
          twinkleSpeed: Math.random() * 0.02 + 0.01,
          twinklePhase: Math.random() * Math.PI * 2
        });
      }
      
      return stars;
    };

    starsRef.current = createStars();

    // Animazione
    const animate = () => {
      ctx.fillStyle = 'rgba(10, 15, 30, 1)';
      ctx.fillRect(0, 0, width, height);

      starsRef.current.forEach(star => {
        // Movimento 3D
        star.z -= star.speed;
        if (star.z <= 0) {
          star.z = 2000;
          star.x = Math.random() * width;
          star.y = Math.random() * height;
        }

        // Calcola posizione proiettata
        const k = 128.0 / star.z;
        const px = (star.x - width / 2) * k + width / 2;
        const py = (star.y - height / 2) * k + height / 2;

        // Effetto twinkle
        star.twinklePhase += star.twinkleSpeed;
        const twinkle = Math.sin(star.twinklePhase) * 0.3 + 0.7;

        // Dimensione basata sulla profondità
        const size = star.size * k * 2;

        // Opacità basata su profondità e twinkle
        const opacity = Math.min(1, star.opacity * twinkle * (2000 - star.z) / 2000);

        // Disegna stella con glow
        if (px >= 0 && px <= width && py >= 0 && py <= height) {
          // Glow esterno
          const gradient = ctx.createRadialGradient(px, py, 0, px, py, size * 3);
          gradient.addColorStop(0, `rgba(255, 255, 255, ${opacity * 0.8})`);
          gradient.addColorStop(0.3, `rgba(200, 220, 255, ${opacity * 0.4})`);
          gradient.addColorStop(1, 'rgba(100, 150, 255, 0)');
          
          ctx.fillStyle = gradient;
          ctx.beginPath();
          ctx.arc(px, py, size * 3, 0, Math.PI * 2);
          ctx.fill();

          // Nucleo stella
          ctx.fillStyle = `rgba(255, 255, 255, ${opacity})`;
          ctx.beginPath();
          ctx.arc(px, py, Math.max(0.5, size), 0, Math.PI * 2);
          ctx.fill();
        }
      });

      animationFrameRef.current = requestAnimationFrame(animate);
    };

    animate();

    // Cleanup
    return () => {
      window.removeEventListener('resize', resizeCanvas);
      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current);
      }
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 0,
        background: 'linear-gradient(180deg, #0a0f1e 0%, #1a1f3a 50%, #0f1429 100%)',
      }}
    />
  );
};

export default StarryBackground;

